import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import { Globals } from '.././globals';


@Injectable()
export class gatekeyService {
  user:any;
  reqHeader = new HttpHeaders({ 'No-Auth':'True'});
  constructor(private http: HttpClient,private _global:Globals) {
   
  }
   readonly rootUrl = this._global.siteUrl;

   addgatekey(Obj,id){
    const body = {
      gateObj:Obj,
      imageId:id
     }
    
     return this.http.post(this.rootUrl + 'gatekey/addgatekey', body);
   
   }

   updategatekey(Obj,imgid,id){
    const body = {
      gateObj:Obj,
      imageId:imgid,
      id:id,
     }
    
     return this.http.post(this.rootUrl + 'gatekey/updategatekey', body);
   
   }

   gatekeylist(pgObj){
    const body = {
      start:pgObj[0],
      end:pgObj[1],
      search:pgObj[2],
      user:pgObj[3],
     }
     return this.http.post(this.rootUrl + 'gatekey/gatekeylist',body);
   
   }

   editgatekeydetails(Id,userId){
    const body = {
      id:btoa(Id),
      userId:btoa(userId)
     }
     return this.http.post(this.rootUrl + 'gatekey/getgatedetails', body,{ headers: this.reqHeader});
   
   }

   editgatekeyitemdetails(Id){
    const body = {
      id:btoa(Id),
     }
     return this.http.post(this.rootUrl + 'gatekey/getgateitemdetails', body,{ headers: this.reqHeader});
   
   }

   delChallenge(Id){
    const body = {
     id: Id,
     isDeleted:1
   }
   return this.http.post(this.rootUrl + 'gatekey/delChallenge', body);
  }

  getgatekey(obj){
    return this.http.post(this.rootUrl + 'gatekey/getgatekeycontent',obj,{ headers: this.reqHeader});
  }
  addchallenge(Obj){
    const body = {
      gateObj:Obj
     }
    
     return this.http.post(this.rootUrl + 'gatekey/addchallenge', body);
   
   }

   gateclallengelist(pgObj){
    const body = {
      start:pgObj[0],
      end:pgObj[1],
      search:pgObj[2],
      user:pgObj[3],
      streamId:pgObj[4],
     }
     return this.http.post(this.rootUrl + 'gatekey/gateclallengelist',body);
   
   }

   allgateclallengelist(pgObj){
    const body = {
      start:pgObj[0],
      end:pgObj[1],
      search:pgObj[2],
      user:pgObj[3],
      streamId:pgObj[4],
     }
     return this.http.post(this.rootUrl + 'gatekey/allgateclallengelist',body);
   
   }


   editchallengedetails(Id){
    const body = {
      id:btoa(Id),
     }
     return this.http.post(this.rootUrl + 'gatekey/getchallengedetails', body,{ headers: this.reqHeader});
   
   }


   editchallengeitemdetails(Id){
    const body = {
      id:btoa(Id),
     }
     return this.http.post(this.rootUrl + 'gatekey/getchallengeitemdetails', body,{ headers: this.reqHeader});
   
   }
    
}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/gatekey.service.ts